import Image from "next/image";
import styles from "../upsc-prestorming-prelims-test-series/prestorming.module.css";
import Link from "next/link";
import dynamic from "next/dynamic";
const Online = dynamic(() => import("../prestromong-chennai/pre-online"));
import hand from "../../assets/images/upsc/modalnew.png";
import check from "../../assets/images/upsc/check.png";
const Prelims = () => {

    
    
      const prelimslist1 =[
        {cont:"Top-notch quality test:",cont1:"We conduct 48 tests acclaimed for the best approaches and questions to prepare the UPSC prelims test series 2025."},
        {cont:"Extensive range of sources:",cont1:"Highly relevant and precise to advanced strategies and patterns."},
        {cont:"Experts and toppers:",cont1:"Questions are prepared from high-quality online sources and classic books recommended by experts and toppers every year."},
        {cont:"In-detailed solutions:",cont1:"Provide the best answers and approaches to each query with comprehensive insights and explanations."},
        {cont:"All India Ranking:",cont1:"It helps to access the candidate the level of preparation and compete with other sets of talented aspirants."},
        {cont:"The detailed and latest strategy included study plan:",cont1:"All candidates are provided with a timetable to follow regularly, which helps solve the tests quickly. It motivates the candidates, streamlines their learning methodologies, makes them complete the target, and to ensure the preparation is productive and disciplined."}
      ]
 
  return (
    <>
      {/* <div className="container-fluid pt-md-3 pt-lg-4" style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
        <div className="row">
          <div className="col ps-0 pe-0">
          
              <div className="container mb-md-3 mb-xl-3">
                   <div className="row">            
                      <div className="col-12 col-xl-5">
                          <h2 className={`${styles.sectiontitle} pt-3 mb-0`}>
                          Why Shankar IAS Academy?
                          </h2>
                            <ul className={`${styles.ulclass} ps-1 pt-2`}>
                            {prelimlist.map((item,index)=>(
                                  <li
                                    className={`${styles.ulliclass} ${styles.acheiverrank}`}
                                    id={styles.acheiverrankspecial} key={index}
                                  >
                                    <div className="d-inline">
                                      <p className={`${styles.ullispan} d-inline`}>
                                        {item.list}
                                      </p>
                                    </div>
                                  </li>
                              ))}
                            </ul>
                            <p>& Much More...</p>
                        </div>
                        <div className="col-12 col-xl-7 my-md-3 px-xl-5">
                        <iframe className="w-100 videoheight" src="https://www.youtube.com/embed/T-tTKUyRs4I?si=bB_3Rwfipz8P3Qwt" title="The Hindu Daily News Analysis || 28th March 2023 || UPSC Current Affairs || Mains &amp; Prelims &#39;23"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                        </div>
                    </div>
              </div>
        
            </div>
          </div>
        </div> */}
<section className={`${styles.contentbg} `}>
     <div className="container pt-5 pb-4"> 
          <div className="row">
            <div className="col">
              <h2 className={`${styles.sectiontitle1} mb-0`}>Academic Preparation for UPSC Prelims – Join Our Test Series</h2>
               <p className={`${styles.acheiverrank1} mb-0`}>At Shankar IAS Academy, a student’s success in the UPSC is a top priority in the academic
                  curriculum. Our UPSC Prelims Test Series is carefully crafted to ensure that you get access to
                  the very best study resources in order to excel in your UPSC exams.</p>
            </div>
          </div>

      <div className="row pt-3">
          <h4 className={`${styles.sectiontitle1} mb-0`}>Why is your UPSC Prelims Test Series 2025 with Us?</h4>
          
          <p className={`${styles.contl} mb-0`}><Image src={check} alt="check" className={`${styles.checkiconcss} img-fluid pe-2`} />Our UPSC Prelims Test Series 2025 offers an extensive range of features tailored to meet the
          needs of aspiring IAS candidates </p>

          <p className={`${styles.contl} mb-0`}><Image src={check} alt="check" className={`${styles.checkiconcss} img-fluid pe-2`} />Comprehensive Coverage: It comprises a pool of tests that extend to all the areas of content
          in the syllabuses referring to the <br/> UPSC Prelims examination so as to help prepare in detail. </p>

          <p className={`${styles.contl} mb-0`}><Image src={check} alt="check" className={`${styles.checkiconcss} img-fluid pe-2`} />Focused Learning: The IAS Prelims Test Series will enable you to understand all your strong
          areas and areas that you require more focus on. </p>
            
      </div>

      <div className="row pt-3">
          <h4 className={`${styles.sectiontitle1} mb-0`}>Major Benefits of our GS Prelims Test Series</h4>
          <p className={`${styles.contl} mb-0`}><Image src={hand} alt="check" className={`${styles.handicon} img-fluid `} />45 Exclusive Tests: Learn by taking 45 different exercises and 3 simulations of the actual exam environment. </p>
          <p className={`${styles.contl} mb-0`}><Image src={hand} alt="check" className={`${styles.handicon} img-fluid `} />17 CSAT Tests: In our program, you will find 17 exhaustive GS Prelims tests covering sectional and full-length tests.</p>
          <p className={`${styles.contl} mb-0`}><Image src={hand} alt="check" className={`${styles.handicon} img-fluid `} /> In-Depth Discussions: All of them are accompanied by thorough orientation and discussion to explain the concepts and approaches used.</p>
          <p className={`${styles.contl} mb-0`}><Image src={hand} alt="check" className={`${styles.handicon} img-fluid `} /> AI-Based Performance Analysis: Our site features state of the art AI tools for performance analysis where you get the complete all India ranking system for comparisons. </p>
          <p className={`${styles.contl} mb-0`}><Image src={hand} alt="check" className={`${styles.handicon} img-fluid `} /> Special Focus Areas: We give tests on particular subjects wherein information revealed is distinctive from a normal class test, to prepare you for the <br/> UPSC Prelims Test Series for IAS. </p>
          <p className={`${styles.contl} mb-0`}><Image src={hand} alt="check" className={`${styles.handicon} img-fluid `} />Current Affairs and Special Topics: Prepare yourself with classes from general affairs and special areas of Environment Governance, International Organizations, Arts and Culture, and Science and Technology.  </p>
          <p className={`${styles.contl} mb-0`}><Image src={hand} alt="check" className={`${styles.handicon} img-fluid `} /> Supplementary Materials: Also check divided and analyzed syllabus of UPSC Prelims papers of past 8 years for better preparation of the Test Series for UPSC Prelims 2025. </p>  
      </div>

       <div className="row pt-3">
            <div className="col">
              <h2 className={`${styles.sectiontitle1} mb-0`}>Enroll for our Prelims Test Series Now!</h2>
               <p className={`${styles.acheiverrank1} mb-0`}>Begin your journey to a career in the civil service with confidence. Join our Prelims Test Series right now and become the first step on the road to success. Let us use our experienced staff
               and quality services to help you through the academic year.</p>
               <p className={`${styles.acheiverrank1} mb-0`}>For more information about our UPSC Prelims Test Series, feel free to contact us or visit our
               website. Join TODAY to make your learning on UPSC coaching REALLY WORK FOR YOU!</p>
            </div>
          </div>

       {/*   <div className="row">
            <div className="col">
              <h2 className={`${styles.sectiontitle1} mb-0`}>What is Shankar IAS Academy's UPSC Prelims Test Series 2025?</h2>
            </div>
          </div>

          <div className="row pt-3">
            <p className={`${styles.acheiverrank1} mb-0`}>Shankar IAS Academy's UPSC Prelims Test Series 2025 is a comprehensive program designed specifically to help aspirants prepare for the UPSC Civil Services Examination.</p>
            <p className={`${styles.acheiverrank1}`}>The test series is designed to provide candidates with a rigorous and realistic simulation of the actual UPSC Prelims examination.</p>
          </div>

          <div className="row">
            <div className="col">
              <h2 className={`${styles.sectiontitle1} mb-0`}>What makes Shankar IAS Academy's UPSC Prelims Test Series 2025 unique?</h2>
            </div>
          </div>

          <div className="row pt-3">
            <p className={`${styles.acheiverrank1} mb-0`}>The test series is conducted by experienced and highly qualified faculty members who have a deep understanding of the UPSC Civil Services Examination.</p>
            <p className={`${styles.acheiverrank1}`}>The faculty provides expert guidance and support to help candidates understand the nuances of the examination and develop their skills.</p>
          </div>

          <div className="row pt-3">
            <p className={`${styles.acheiverrank1} mb-0`}>The test series includes up-to-date study materials and a series of mock tests that simulate the actual UPSC Prelims examination. </p>
            <p className={`${styles.acheiverrank1}`}>The mock tests are designed to test the candidate's knowledge and abilities, and provide them with valuable feedback on their performance.</p>
          </div> */}

    </div>
    </section>   


       {/*  <div className="container pt-3">
        

          <div className="row">
            <div className="col">
              <h2 className={`${styles.sectiontitle1} mb-0`}>UPSC Mock Test 2025: Key to Success</h2>
            </div>
          </div>

          <div className="row pt-3">
            <p className={`${styles.acheiverrank1} mb-0`}>Shankar IAS Academyspos; UPSC Prelims Test Series 2025 includes a series of mock tests that simulate the actual UPSC Prelims examination. </p>
            <p className={`${styles.acheiverrank1}`}>The mock tests are designed to test the candidate&apos;s knowledge and abilities, and provide them with valuable feedback on their performance.</p>
          </div>

          <div className="row pt-3">
            <p className={`${styles.acheiverrank1} mb-0`}>The mock tests are conducted under exam conditions, providing candidates with an authentic experience of what it is like to take the UPSC Prelims examination.</p>
            <p className={`${styles.acheiverrank1}`}>The results of the mock tests are used to identify areas of weakness and help candidates focus their efforts on the areas where they need the most improvement.</p>
          </div>

          <div className="row">
            <div className="col">
              <h2 className={`${styles.sectiontitle1} mb-0`}>Expert Guidance: A Game-Changer</h2>
            </div>
          </div>

          <div className="row pt-3">
            <p className={`${styles.acheiverrank1} mb-0`}>The test series is conducted by experienced and highly qualified faculty members who have a deep understanding of the UPSC Civil Services Examination.</p>
            <p className={`${styles.acheiverrank1}`}>The faculty provides expert guidance and support to help candidates understand the nuances of the examination and develop their skills.</p>
          </div>

          <div className="row pt-3">
            <p className={`${styles.acheiverrank1} mb-0`}>The faculty also provides regular feedback and guidance on the performance of the candidates, helping them to understand their strengths and weaknesses.</p>
            <p className={`${styles.acheiverrank1}`}>This feedback is invaluable in helping candidates make the necessary improvements to their preparation and boost their chances of success in the UPSC Prelims examination.</p>
          </div>

        </div>

        <div className="container pt-3">
          

          <div className="row">
            <div className="col">
              <h2 className={`${styles.sectiontitle1} mb-0`}>Comprehensive Study Materials: A Key Resource</h2>
            </div>
          </div>

          <div className="row pt-3">
            <p className={`${styles.acheiverrank1} mb-0`}>Shankar IAS Academy&apos;s UPSC Prelims Test Series 2025 includes up-to-date study materials that are specifically designed to help aspirants prepare for the</p>
            <p className={`${styles.acheiverrank1}`}>UPSC Civil Services Examination. The study materials are designed to cover all the important topics that are likely to appear in the UPSC Prelims examination.</p>
          </div>

          <div className="row pt-3">
            <p className={`${styles.acheiverrank1} mb-0`}>The study materials are updated regularly to reflect the latest trends and developments in the examination, ensuring that candidates are always </p>
            <p className={`${styles.acheiverrank1}`}>well-prepared for the latest version of the UPSC Prelims examination.</p>
          </div>

        </div>

        <div className="container">
          <div className="row pt-3">
            <div className="col">
              <h2 className={`${styles.sectiontitle1} mb-`}>Advantages of Shankar IAS Academy UPSC Prelims Online Test Series 2025</h2>
            </div>
          </div>

          <div className="row">
        <div className="col">


            <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                {prelimslist1.map((item,index)=>(
                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                    <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                        <span className={`${styles.acheivername}`}>{item.cont} &nbsp;</span><span className={`${styles.acheiverrank}`}> {item.cont1}</span>
                        </p>
                    </div>
                </li>
              ))}
           </ul>

    </div>
    </div>
  
        </div>*/}

</>
);
};

export default Prelims;